module.exports = __webpack_public_path__ + "img/no-planning.bf653752.png";